import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import dayjs from "dayjs";
import { money } from "./boleteraHelper";

/*
  Comprobante en pantalla. Es HTML imprimible en vez de un PDF del servidor: el navegador
  no puede hablar con una impresora térmica de todos modos, y así el boleto se entrega sin
  otra llamada de red — el operador puede ir sin señal.
*/
const Comprobante = ({ venta, salida, operador, boleto, onClose }) => {
  const imprimir = () => window.print();

  return (
    <Modal isOpen={!!venta} toggle={onClose} centered>
      {venta && (
        <>
          <ModalHeader toggle={onClose}>Boleto {venta.folio}</ModalHeader>
          <ModalBody>
            <div id="boletera-comprobante" className="boletera-comprobante">
              <div style={{ textAlign: "center", marginBottom: 10 }}>
                <div style={{ fontWeight: 700, fontSize: "15px" }}>{salida?.ramal_nombre}</div>
                <div style={{ fontSize: "11.5px", color: "#777a89" }}>
                  Unidad {salida?.unidad ?? "-"} · Salida {salida?.hora}
                </div>
              </div>

              <div className="boletera-comprobante-row">
                <span>Folio</span>
                <strong>{venta.folio}</strong>
              </div>
              <div className="boletera-comprobante-row">
                <span>Fecha</span>
                <span>{dayjs(venta.sold_at).format("DD/MM/YYYY HH:mm")}</span>
              </div>
              {operador && (
                <div className="boletera-comprobante-row">
                  <span>Operador</span>
                  <span>{operador}</span>
                </div>
              )}

              <hr />

              {(venta.lineas ?? []).map((l, i) => (
                <div key={i} className="boletera-comprobante-row">
                  <span>
                    {l.cantidad} × {l.tipo}
                  </span>
                  <span>{money(l.subtotal)}</span>
                </div>
              ))}

              <hr />

              <div className="boletera-comprobante-row" style={{ fontSize: "16px", fontWeight: 700 }}>
                <span>Total</span>
                <span>{money(venta.total)}</span>
              </div>
              <div style={{ textAlign: "center", fontSize: "10.5px", color: "#777a89", marginTop: 10 }}>
                {venta.boletos} boleto(s) · conserve este comprobante
              </div>

              {/* Va dentro de #boletera-comprobante: fuera, el @media print lo oculta */}
              {boleto?.whatsapp && (
                <div style={{ textAlign: "center", fontSize: "10.5px", color: "#777a89", marginTop: 8 }}>
                  Quejas y sugerencias por WhatsApp: {boleto.whatsapp}
                  {boleto.whatsapp_qr && (
                    <img
                      src={boleto.whatsapp_qr}
                      alt="WhatsApp de quejas y sugerencias"
                      className="boletera-comprobante-qr"
                    />
                  )}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={imprimir}>
              <i className="fa fa-print"></i> Imprimir
            </Button>
            <Button color="secondary" onClick={onClose}>
              <i className="fa fa-times"></i> Cerrar
            </Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};

export default Comprobante;
